import { render, staticRenderFns } from "./BuilderListItemConfig.vue?vue&type=template&id=d71cdf84"
import script from "./BuilderListItemConfig.vue?vue&type=script&lang=js"
export * from "./BuilderListItemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports